﻿export function setTitle(title: string) {
	document.title = title;	
}